import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from "rxjs";
import { environment } from '../../../../environments/environment';
const _ = require('lodash');

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  private SERVER_URL = `${environment.API_URL}`;

  constructor(private httpClient: HttpClient) { }

  public saveLocation(data: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-article-location/companyArticleLocation/saveLocation',
        { data },
        { headers });
  }

  public updateLocation(data: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-article-location/companyArticleLocation/updateLocation',
        { data },
        { headers });
  }

  public getLocations() {
    return this.httpClient.get(this.SERVER_URL + 'company-article-location/companyArticleLocation/getLocations');
  }

  public getLocationsForArticle(articleId: any): Observable<any> {
    const params = new HttpParams()
      .set('articleId', articleId);

    return this.httpClient.get(
      this.SERVER_URL + 'company-article-location/CompanyArticleLocation/getLocationsForArticle',
      { params }
    );
  }

  public deleteLocation(id: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-article-location/companyArticleLocation/deleteLocation',
        { id },
        { headers });
  }

  public getArticlesForLocation(locationId: any): Observable<any> {
    return this.httpClient.get(this.SERVER_URL + 'company-article-location/companyArticleLocation/getArticlesForLocation', {
      params: new HttpParams().set('locationId', locationId)
    });
  }

  public removeArticleFromLocation(locationId: any, articleId: any, gestiuneId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-article-location/companyArticleLocation/removeArticleFromLocation',
        { locationId, articleId, gestiuneId },
        { headers });
  }
  public  addArticleToLocation(locationId: any, articleId: any, gestiuneId: any) {
    const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});
    return this.httpClient.post(this.SERVER_URL + 'company-article-location/companyArticleLocation/addArticleToLocation',
        { locationId, articleId, gestiuneId },
        { headers });
  }
}